"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptimizationErrors = exports.OptimizationRequestErrorCodes = exports.OptimizeFor = exports.RouteItemType = exports.OptimizationOrigin = exports.OptimizationResponseType = exports.OPTIMIZATION_TYPE = void 0;
var OPTIMIZATION_TYPE;
(function (OPTIMIZATION_TYPE) {
    OPTIMIZATION_TYPE[OPTIMIZATION_TYPE["ANONYMOUS"] = 1] = "ANONYMOUS";
    OPTIMIZATION_TYPE[OPTIMIZATION_TYPE["NAMED_VRP"] = 2] = "NAMED_VRP";
    OPTIMIZATION_TYPE[OPTIMIZATION_TYPE["NAMED_PDP"] = 3] = "NAMED_PDP";
    OPTIMIZATION_TYPE[OPTIMIZATION_TYPE["ROUTE_BASED"] = 4] = "ROUTE_BASED";
    OPTIMIZATION_TYPE[OPTIMIZATION_TYPE["CREW_BASED"] = 5] = "CREW_BASED";
    OPTIMIZATION_TYPE[OPTIMIZATION_TYPE["COMBINED"] = 6] = "COMBINED";
})(OPTIMIZATION_TYPE || (exports.OPTIMIZATION_TYPE = OPTIMIZATION_TYPE = {}));
var OptimizationResponseType;
(function (OptimizationResponseType) {
    OptimizationResponseType["RouteInfo"] = "route_info";
    OptimizationResponseType["Task"] = "task";
    OptimizationResponseType["ActualBreak"] = "actual_break";
    OptimizationResponseType["PreassignedBreak"] = "preassigned_break";
    OptimizationResponseType["Directions"] = "directions";
    OptimizationResponseType["UnassignedTask"] = "unassigned_task";
})(OptimizationResponseType || (exports.OptimizationResponseType = OptimizationResponseType = {}));
var OptimizationOrigin;
(function (OptimizationOrigin) {
    OptimizationOrigin["ROUTE_OPTIMIZATION"] = "route_optimization";
    OptimizationOrigin["RERUN_ROUTE_OPTIMIZATION"] = "rerun_route_optimization";
    OptimizationOrigin["ROUTE_OPTIMIZATION_QUOTES"] = "route_optimization_quotes";
    OptimizationOrigin["AVAILABILITY_CALCULATION"] = "availability_calculation";
    OptimizationOrigin["SCHEDULED_ROUTE_OPTIMIZATION"] = "scheduled_route_optimization";
    OptimizationOrigin["VRP_AUTO_DISPATCH"] = "vrp_auto_dispatch";
    OptimizationOrigin["VRP_AUTO_DISPATCH_QUOTES"] = "vrp_auto_dispatch_quotes";
    OptimizationOrigin["QUOTES_CACHE_REFRESH"] = "quotes_cache_refresh";
})(OptimizationOrigin || (exports.OptimizationOrigin = OptimizationOrigin = {}));
var RouteItemType;
(function (RouteItemType) {
    RouteItemType["Break"] = "break";
})(RouteItemType || (exports.RouteItemType = RouteItemType = {}));
var OptimizeFor;
(function (OptimizeFor) {
    OptimizeFor["CUSTOM"] = "custom";
    OptimizeFor["NEXT_SHIFT"] = "next_shift";
})(OptimizeFor || (exports.OptimizeFor = OptimizeFor = {}));
var OptimizationRequestErrorCodes;
(function (OptimizationRequestErrorCodes) {
    OptimizationRequestErrorCodes[OptimizationRequestErrorCodes["NoTasksFound"] = 400] = "NoTasksFound";
    OptimizationRequestErrorCodes[OptimizationRequestErrorCodes["NoDriversFound"] = 401] = "NoDriversFound";
    OptimizationRequestErrorCodes[OptimizationRequestErrorCodes["NoDriversFoundAnonymous"] = 402] = "NoDriversFoundAnonymous";
    OptimizationRequestErrorCodes[OptimizationRequestErrorCodes["NoDriversFoundForUserTypes"] = 403] = "NoDriversFoundForUserTypes";
    OptimizationRequestErrorCodes[OptimizationRequestErrorCodes["NoResourcesWorkingDuringTimeWindow"] = 404] = "NoResourcesWorkingDuringTimeWindow";
    OptimizationRequestErrorCodes[OptimizationRequestErrorCodes["MissingSchedules"] = 405] = "MissingSchedules";
    OptimizationRequestErrorCodes[OptimizationRequestErrorCodes["TasksOutsideTimeWindow"] = 406] = "TasksOutsideTimeWindow";
})(OptimizationRequestErrorCodes || (exports.OptimizationRequestErrorCodes = OptimizationRequestErrorCodes = {}));
exports.OptimizationErrors = (_a = {},
    _a[OptimizationRequestErrorCodes.NoTasksFound] = {
        message: 'No tasks found for optimization',
        key: 'NO_TASKS_FOUND_ERROR'
    },
    _a[OptimizationRequestErrorCodes.NoDriversFound] = { message: 'No drivers found', key: 'NO_DRIVERS_FOUND_ERROR' },
    _a[OptimizationRequestErrorCodes.NoDriversFoundAnonymous] = {
        message: 'No drivers for specified user types found',
        key: 'NO_DRIVERS_FOUND_ANONYMOUS_ERROR'
    },
    _a[OptimizationRequestErrorCodes.NoDriversFoundForUserTypes] = {
        message: 'No drivers found for all selected user types',
        key: 'NO_DRIVERS_FOUND_FOR_USER_TYPES_ERROR'
    },
    _a[OptimizationRequestErrorCodes.NoResourcesWorkingDuringTimeWindow] = {
        message: "Couldn't find drivers that are working during the optimization time window",
        key: 'NO_RESOURCES_WORKING_DURING_TIME_WINDOW_ERROR'
    },
    _a[OptimizationRequestErrorCodes.MissingSchedules] = {
        message: 'Could not find any schedule for some of the runs',
        key: 'MISSING_SCHEDULES_ERROR'
    },
    _a[OptimizationRequestErrorCodes.TasksOutsideTimeWindow] = {
        message: 'Tasks outside the optimization or resources time window',
        key: 'TASKS_OUTSIDE_TIME_WINDOW_ERROR'
    },
    _a);
//# sourceMappingURL=optimization_type.js.map